import { useSyncExternalStore } from "react";

type IMedia = `(${string}:${string})`

export const CreateMediaContext = (query: IMedia) => {

	const get = () => window.matchMedia(query).matches

	const subscribe = (callback: () => void) => {
		const q = window.matchMedia(query)
		q.addEventListener('change', callback)
		return () => q.removeEventListener('change', callback)
	} 

	const useMedia = () => {
		return useSyncExternalStore(subscribe, () => get())
	}

	return useMedia
}